import type { SVGProps } from 'react';

const DriveOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7363 9.16667L14.4039 14.125V20.5H12.3366V19.0833H4.06732V20.5H2V14.125L3.67431 9.16667H12.7363ZM6.47919 16.6042V18.375H9.92472V16.6042H6.47919ZM4.41187 14.8333C3.83991 14.8333 3.37821 15.3079 3.37821 15.8958C3.37821 16.4837 3.83991 16.9583 4.41187 16.9583C4.98383 16.9583 5.44553 16.4837 5.44553 15.8958C5.44553 15.3079 4.98383 14.8333 4.41187 14.8333ZM11.992 14.8333C11.4201 14.8333 10.9584 15.3079 10.9584 15.8958C10.9584 16.4837 11.4201 16.9583 11.992 16.9583C12.564 16.9583 13.0257 16.4837 13.0257 15.8958C13.0257 15.3079 12.564 14.8333 11.992 14.8333ZM4.41187 10.2292L3.37821 13.4167H13.0257L11.992 10.2292H4.41187Z"
    />
    <path fill="currentColor" d="M19.2276 13.4166H21.9841V20.4999H19.2276V13.4166Z" />
    <path
      fill="currentColor"
      d="M10.2693 4.61916L11.1143 3.5L22 12.1841L21.155 13.3032L10.2693 4.61916Z"
    />
    <path
      fill="currentColor"
      d="M19.7445 11.9999H20.9504L21.4672 12.7083V14.1249H19.7445V11.9999Z"
    />
  </svg>
);
export default DriveOut;
